import { StudioDetailsTabs } from "entities/studios/types";
import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useStudiosPage } from "../../context";
import General from "./components/General";
import ProductDetails from "./components/ProductDetails";
import Tabs from "./components/Tabs";
import Translations from "./components/Translations";
import { StudioDetailsProvider, useStudioDetails } from "./context";
import ActionButton from "./components/ActionButton";

const StudioDetailsContainer: FC = () => (
  <StudioDetailsProvider>
    <StudioDetails />
    <ProductDetails />
  </StudioDetailsProvider>
);

const StudioDetails: FC = () => {
  const { studioDetailsDrawer } = useStudiosPage();
  const {
    studioDetails,
    selectedTab,
    onCloseStudioDetails,
  } = useStudioDetails();

  const TAB_CONTENT: Record<StudioDetailsTabs, FC> = {
    [StudioDetailsTabs.General]: General,
    [StudioDetailsTabs.Translations]: Translations,
  };

  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={studioDetails?.name}
      isOpen={studioDetailsDrawer.isOpen}
      onCloseDrawer={onCloseStudioDetails}
      width={640}
      headingRight={<ActionButton />}
      headingBottom={<Tabs />}
    >
      <ContentComponent />
    </Drawer>
  );
};

export default StudioDetailsContainer;
